import { __extends } from "tslib";
import * as React from 'react';
import * as color from 'color';
export var colorPickerBoardKey = 'color-picker-board';
var ColorPickerBoard = /** @class */ (function (_super) {
    __extends(ColorPickerBoard, _super);
    function ColorPickerBoard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.gradient = null;
        _this.onMarkerDragStart = function (e) {
            e.preventDefault();
            window.addEventListener('mousemove', _this.onMarkerDrag);
            window.addEventListener('touchmove', _this.onMarkerDrag);
            window.addEventListener('mouseup', _this.onMarkerDragEnd);
            window.addEventListener('touchend', _this.onMarkerDragEnd);
            window.addEventListener('touchcancel', _this.onMarkerDragEnd);
            if (_this.gradient) {
                _this.gradientRect = _this.gradient.getBoundingClientRect();
            }
            _this.setNewColorByMouseEvent(e);
        };
        _this.clamp = function (num, min, max) {
            return (num <= min ? min : num >= max ? max : num);
        };
        _this.onMarkerDrag = function (e) {
            _this.setNewColorByMouseEvent(e);
        };
        _this.onMarkerDragEnd = function () {
            window.removeEventListener('touchmove', _this.onMarkerDrag);
            window.removeEventListener('mousemove', _this.onMarkerDrag);
            window.removeEventListener('touchcancel', _this.onMarkerDragEnd);
            window.removeEventListener('touchend', _this.onMarkerDragEnd);
            window.removeEventListener('mouseup', _this.onMarkerDragEnd);
        };
        _this.getSVByMouseEvent = function (e) {
            var eventX = 0;
            var eventY = 0;
            var s = 0;
            var v = 0;
            eventX = e.clientX ? e.clientX : e.touches[0].clientX;
            eventY = e.clientY ? e.clientY : e.touches[0].clientY;
            if (_this.gradientRect) {
                var x = eventX - _this.gradientRect.left;
                var y = eventY - _this.gradientRect.top;
                s = _this.clamp((100 * x) / _this.gradientRect.width, 0, 100);
                v = _this.clamp(100 - (100 * y) / _this.gradientRect.height, 0, 100);
            }
            return { s: s, v: v };
        };
        _this.setNewColorByMouseEvent = function (e) {
            var _a = _this.props, onChange = _a.onChange, current = _a.current;
            var _b = _this.getSVByMouseEvent(e), s = _b.s, v = _b.v;
            onChange('', color({ h: current.hue(), s: s, v: v }));
        };
        _this.setBoardRef = function (e) {
            _this.gradient = e;
        };
        return _this;
    }
    ColorPickerBoard.prototype.componentWillUnmount = function () {
        this.onMarkerDragEnd();
    };
    ColorPickerBoard.prototype.render = function () {
        var current = this.props.current;
        var hue = current.saturationv(100).lightness(50);
        var style = {
            left: current.saturationv() + "%",
            top: 100 - current.value() + "%",
        };
        return (React.createElement("div", { className: 'color-picker-board', "data-hook": 'color-picker-hsb', ref: this.setBoardRef, onMouseDown: this.onMarkerDragStart, onTouchStart: this.onMarkerDragStart },
            React.createElement("div", { className: 'hue-container', style: { background: hue.hex() } }),
            React.createElement("div", { className: 'saturation-container' }),
            React.createElement("div", { className: 'brightness-container' }),
            React.createElement("div", { className: 'handle', style: style })));
    };
    return ColorPickerBoard;
}(React.PureComponent));
export { ColorPickerBoard };
//# sourceMappingURL=index.js.map